import type { XYChartXAxisProps } from '../types/xy-chart.js';

export const XAxis = (props: XYChartXAxisProps) => null;

XAxis['displayName'] = 'XYChart.XAxis';
